import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41a9691b")

_pushScopeId("data-v-41a9691b")
const _hoisted_1 = { class: "head" }
const _hoisted_2 = {
  key: 0,
  class: "view"
}
const _hoisted_3 = { class: "contents" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")

  return (_openBlock(), _createBlock("div", {
    class: ["root", { 'is-top': _ctx.isTop || _ctx.isLogin }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Header, {
        isHideTitle: _ctx.isTop || _ctx.isLogin
      }, null, 8, ["isHideTitle"])
    ]),
    (_ctx.isLogin || _ctx.data.isLoaded)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
})